import React,{useEffect, useState} from 'react'
import {Table,Tooltip, Button,Form,Input, message, Select,Modal,Popconfirm} from 'antd';
import { EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import qs from 'qs';
import axios from 'axios';
import { SERVER_ADDRESS } from '../../../Config/Config';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const { Option } = Select;

const Subcategorylist = () => {
        const [data,setData] = useState([]);
        const [loading, setLoading] = useState(false);
        const [ismodalOpen,setIsmodalOpen] = useState(false);
        const [record, setRecord] = useState(null); 
        const [categories, setCategories] = useState([]);
        const [form] = Form.useForm();
        const [searchTerm ,setSearchTerm] = useState ('');
        const [filteredData,setFilteredData] = useState([]);

        const handleSearch = (e) =>{
          const searchValue = e.toLowerCase();
          // setSearchTerm(searchValue);
          setFilteredData(
            data.filter((item)=>
              item.sub_category_name.toLowerCase().includes(searchValue)
            )
          )
        }


        useEffect(()=> {

          handleSearch(searchTerm)
      }, [searchTerm, data])


        const columns = [
            {
                title:'Id',
                dataIndex:'sub_category_id',
                sorter:'true',
                sorter: (a, b) => a.sub_category_id - b.sub_category_id,
                width:'10%',
                key:'sub_category_id'
            },
            {
              title:'Category Name',
              dataIndex:'category_name',
              sorter:(a,b)=>a.category_name.localeCompare(b.category_name),
              width:'10%',
              key:'category_name'
          },
            {
                title:'Sub-Category Name',
                dataIndex:'sub_category_name',
                sorter:(a, b)=>a.sub_category_name.localeCompare(b.sub_category_name),
                width:'10%',
                key:'category_name'
            },
            {
                title:'Search Key',
                dataIndex:'sub_category_search_key',
                width:'10%',
                key:'category_search_key',
                render: (text) =>{
                    const displaysearchkey = text.length > 15 ? `${text.slice(0,15)}...` :text;
                    return text.length > 15 ? (
                        <Tooltip title={text} >
                            <span>{displaysearchkey}</span>
                        </Tooltip>
                    ) : (
                        <span>{text}</span>
                    )
                }
            },
            {
                title:'Options',
                width:'10%',
                key:'option',
                render: (_,record) => (
                    <div style={{display:'flex',gap:'8px'}} >
                        <Tooltip title="Edit">
                            <Button type="primary" onClick = {()=>handleEdit(record)}  icon={<EditOutlined />}></Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Popconfirm
                                placement="bottom"
                                title="Delete Category"
                                description="Are you sure to delete category ?"
                                onConfirm={()=>handleDelete(record.sub_category_id)}
                                okText="Yes"
                                cancelText="No"
                            >
                            <Button danger icon={<DeleteOutlined />}></Button>
                            </Popconfirm>
                            
                        </Tooltip>
                    </div>
                )
            }
        ]

        const fetchsubcategories = async (pagination) => {
          setLoading(true);
          try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/subcategory-list`);
            setData(response.data)
            setFilteredData(response.data);
            setLoading(false)
            
          } catch (error) {
            message.error({content:'Error on fetching data',duration:2})
          }finally{
            setLoading(false)
          }
        }
        useEffect(() => {
          const fetchCategories = async () => {
            try {
              const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`); 
              setCategories(response.data); 
            } catch (error) {
              message.error("Failed to fetch categories");
              console.error(error);
            }
          };
          fetchCategories();
        }, []);
        const handleTablechange = () => {
          fetchsubcategories();
      }

        useEffect(()=>{
          fetchsubcategories();
        },[]);

        const handleEdit = (record) => {  
             
          setRecord(record)
          setIsmodalOpen(true);
          
          form.setFieldsValue({
            sub_category_name:record.sub_category_name,
            sub_category_search_key:record.sub_category_search_key,
            category_id:record.category_id
        })
        }

        const handleCancel = ()=>{
          setIsmodalOpen(false)
          setRecord(null)
      }

      const onFinish = async (values) =>{
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/update-subcategory/${record.sub_category_id}`,values)
      if(response.status===200){
          message.success({content:'Category updated successfully',duration:2})
          setIsmodalOpen(false);
          setRecord(null);
          fetchsubcategories();
      }
      else{
          message.error({content:'Failed to add category',duration:2})
      }
      } catch (error) {
          console.log(error)
      }
      }

      const handleDelete = async(id) => {
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/delete-subcategory/${id}`)
          if(response.status===200){
            fetchsubcategories()
            message.success({content:'Sub-category deleted successfully',duration:2})
        }
        else{
            message.error({content:'Failed to delete Sub-category',duration:2})
        }
    } catch (error) {
        message.error({content:'Internal Server error',duration:2})
    }
      }

      
  return (
    <div style={{marginTop:'4rem'}}>

      <Input 
        placeholder={'Search by subcategory'}
        prefix ={<SearchOutlined />}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        style={{ marginBottom: '1rem', width: '23%' }}
      />

  <Table 
        columns={columns}
        dataSource={filteredData}
        rowKey="sub_category_id"
        loading={loading}
        onChange={handleTablechange}
    > 
    </Table>

    <Modal open={ismodalOpen} onCancel={handleCancel} footer={null} title="Edit Sub-Category">
    <Form
        form={form}
      style={{
        backgroundColor:'white',
        width:'30rem',
        marginTop:'2rem',
        padding:'2rem',
        justifySelf:'center',
      }}
      labelCol={{span: 8}}
      wrapperCol={{span:14,offset:1}}
      onFinish={onFinish}
  >   
        <Form.Item label="Sub-Category Name" name="sub_category_name"  rules={[{ required: true, message: 'Enter the category name' }]}><Input placeholder="Enter Subcategory" ></Input></Form.Item>
        <Form.Item label="Search Key" name="sub_category_search_key"  rules={[{ required: true, message: 'Enter the category search key name' }]}><Input placeholder="Enter search key" ></Input></Form.Item>
        <Form.Item label="Category" name="category_id" rules={[{required:true, message:'Select the category'}]}>
            <Select placeholder="Select a category">
                {categories.map((category)=>(
                    <Option key={category.category_id} value={category.category_id}>{category.category_name}</Option>
                ))}
            </Select></Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
  
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>  
      </Form>
    </Modal>

    </div>
  )
}

export default Subcategorylist